// Picks the best "Powered by Opendate" logo variant for a given widget
// background color. Two checks:
//   1. light vs dark — picks the broad family (dark-on-light vs light-on-dark)
//   2. clash with the brand red icon — when the bg sits too close to #FF595E
//      the colorful variant's icon visually disappears, so we fall back to a
//      monochrome silhouette.
//
// Festival/club paths leave widgetConfig empty so background_color falls
// through to '#ffffff' here, which yields the full-color variant — visually
// equivalent to the long-standing /opendate_logo.png.

import { colord, extend } from 'colord';
import a11yPlugin from 'colord/plugins/a11y';

extend([a11yPlugin]);

const BRAND_RED = '#FF595E';
const CLASH_CONTRAST = 2.0;

export const LOGO_VARIANTS = {
  fullColor: '/Opendate_logo-horizontal-full-color.png',
  whiteRed:  '/Opendate_logo-horizontal-white-red-for-dark-background.png',
  monoWhite: '/Opendate_logo-horizontal-white.png',
  monoBlack: '/Opendate_logo-horizontal-black.png'
};

const pickOpendateLogoVariant = (backgroundColor) => {
  const c = colord(backgroundColor || '#ffffff');
  if (!c.isValid()) return LOGO_VARIANTS.fullColor;

  const clashesWithBrand = c.contrast(BRAND_RED) < CLASH_CONTRAST;

  if (c.isLight()) {
    return clashesWithBrand ? LOGO_VARIANTS.monoBlack : LOGO_VARIANTS.fullColor;
  }
  return clashesWithBrand ? LOGO_VARIANTS.monoWhite : LOGO_VARIANTS.whiteRed;
};

export default pickOpendateLogoVariant;
